var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EdsIdMapperService } from '../services/eds-id-mapper/eds-id-mapper.service';
import { of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { NavigableComponent } from '../model/navigable-component';
import { NavigationService } from '../services/navigation/navigation.service';
import { PageNames } from '../shared/page-names.enum';
import { ErrorMessageConstants } from '../shared/error-message-constants';
import { TvShopStateService } from '../services/state/tv-shop-state.service';
var DeepLinkingComponent = /** @class */ (function (_super) {
    __extends(DeepLinkingComponent, _super);
    function DeepLinkingComponent(edsIdMapper, route, router, stateService, navigationService) {
        var _this = _super.call(this, navigationService) || this;
        _this.edsIdMapper = edsIdMapper;
        _this.route = route;
        _this.router = router;
        _this.stateService = stateService;
        _this.navigationService = navigationService;
        _this.packs = [];
        return _this;
    }
    DeepLinkingComponent.prototype.ngAfterViewInit = function () {
        this.navigationService.resetNavigation();
    };
    DeepLinkingComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.navigationService.clearNavigation();
    };
    DeepLinkingComponent.prototype.ngOnInit = function () {
        this.stateService.setLoading(true);
        this.processPacks();
        this.navigationService.setCurrentPageComponent(PageNames.DEEP_LINKING);
    };
    DeepLinkingComponent.prototype.processPacks = function () {
        var _this = this;
        var entertainmentPacks = this.stateService.selectSnapshot(function (state) { return state.tvShopEntertainmentPacks; });
        this.mapParametersAndGetOmapiIds().subscribe(function (omapiIds) {
            var filteredEntertainmentPacks = _this.filterPacksByOmapiId(entertainmentPacks, omapiIds);
            if (filteredEntertainmentPacks.length === 1) {
                _this.stateService.setSelectedTvShopEntertainmentPack(filteredEntertainmentPacks[0]);
                _this.router.navigateByUrl("/product-details/" + filteredEntertainmentPacks[0].omapiId + '?origin=deeplink-direct');
            }
            else {
                if (filteredEntertainmentPacks.length > 2) {
                    filteredEntertainmentPacks.splice(filteredEntertainmentPacks.length - 2, filteredEntertainmentPacks.length);
                }
                _this.packs = filteredEntertainmentPacks;
            }
            _this.stateService.setLoading(false);
        }, function (error) {
            _this.stateService.handleError(ErrorMessageConstants.ERROR_FETCHING_ENTERTAINMENT_PACKS, error);
        });
    };
    DeepLinkingComponent.prototype.mapParametersAndGetOmapiIds = function () {
        var _this = this;
        return this.route.queryParamMap.pipe(mergeMap(function (params) {
            _this.titleType = params.get('Type') ? params.get('Type') : '';
            var edsProductIdParamKey = _this.compareCaseInsensitiveAndGetKey(params);
            var unProcessedEdsProductIds = params.get(edsProductIdParamKey);
            if (unProcessedEdsProductIds) {
                var ids = _this.splitParamsOnSpecialCharactersAndFilterOutNaN(unProcessedEdsProductIds);
                return _this.edsIdMapper.mapEdsIdsToOmapiIds(ids);
            }
            return of([]);
        }));
    };
    DeepLinkingComponent.prototype.filterPacksByOmapiId = function (entertainnmentPacks, omapiIds) {
        var packsToCompare = [];
        omapiIds.forEach(function (omapiId) {
            var entertainmentPack = entertainnmentPacks.filter(function (pack) { return pack.omapiId === omapiId + ''; }).pop();
            if (entertainmentPack) {
                packsToCompare.push(entertainmentPack);
            }
        });
        return packsToCompare;
    };
    DeepLinkingComponent.prototype.splitParamsOnSpecialCharactersAndFilterOutNaN = function (unProcessedEdsProductIds) {
        var splitted = (unProcessedEdsProductIds + '').split(/[ %,.\-_]+/);
        return splitted.filter(function (id) { return !isNaN(+id); });
    };
    DeepLinkingComponent.prototype.compareCaseInsensitiveAndGetKey = function (params) {
        return params.keys.filter(function (paramName) { return (paramName + '')
            .toLowerCase()
            .trim() === 'edsproductids'; }).pop();
    };
    return DeepLinkingComponent;
}(NavigableComponent));
export { DeepLinkingComponent };
